__turbopack_context__.v({
  "footer": "CancelApprovalModal-module__aSvxJG__footer",
  "modalContent": "CancelApprovalModal-module__aSvxJG__modalContent",
});
